import { render, staticRenderFns } from "./FairnessSubplotAbsolute.vue?vue&type=template&id=481d98da&"
import script from "./FairnessSubplotAbsolute.vue?vue&type=script&lang=js&"
export * from "./FairnessSubplotAbsolute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports